import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import TopNavBar from '../../../TopNavBar';
import './OrbitPageLayout.css';

const OrbitPageLayout = ({ children }) => {
  useEffect(() => {
    document.body.classList.add('awsui-visual-refresh');
    return () => document.body.classList.remove('awsui-visual-refresh');
  }, []);

  return (
    <div className="orbit-page">
      <TopNavBar />
      {children}
    </div>
  );
};

OrbitPageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OrbitPageLayout;
